module.exports = __webpack_public_path__ + "static/img/1.328e1913.png";